import React, { useState, useEffect } from "react";
import API from "../axios";
import { motion } from "framer-motion";
import "../style/birthday.css";
import cake from "../assets/user.png";

const Birthday = () => {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const empDetails = JSON.parse(localStorage.getItem("empDetails") || "{}");
  
  const imageUrl = `https://psmport.pothysswarnamahalapp.com/AllStaffsImage/`


  const fetchBirthdays = async () => {
    try {
      setLoading(true);

      const res = await API.post("/birthdays", 
       { branch: empDetails.branchname }
      );

      console.log(res.data);

      setData(res.data);
    } catch (err) {
      console.error("Error fetching birthdays", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBirthdays();
  }, []);

  // 🎯 animation
  const cardVariant = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8 }
    }
  };

  // 📅 format date 
  const formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short"
    });
  };

  return (
    <div className="container mt-3 pt-lg-3">

      <h3 className="text-center mb-4 birthday-title">This Month Birthday Buddies</h3>

      {loading ? (
        <div className="text-center fw-bold">Loading...</div>
      ) : data.length === 0 ? (
        <div className="text-center fw-bold">No Birthdays Today</div>
      ) : (
        <div className="row">

          {/* {data.map((item, index) => (
            <motion.div
              key={item.employee_code}
              className="col-md-6 col-lg-3 mb-5 "
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div className="birthday-card shadow">

           
                <div className="birthday-img">
                  <img src={cake} alt="birthday" />
                </div>

                <div className="birthday-info">

                  <h5 className="emp-name">{item.emp_name}</h5>

                  <p className="dept">{item.department}</p>

                  <p className="date">
                    {formatDate(item.date_of_birth)}
                  </p>

                </div>

              </div>
            </motion.div>
          ))} */}


        {data.map((item, index) => {

          const birthdayDate = new Date(item.date_of_birth);

          const today = new Date();

          const birthDay = birthdayDate.getDate();
          const currentDay = today.getDate();

          let cardClass = "";

          // 🎉 Today Birthday
          if (birthDay === currentDay) {
            cardClass = "today-birthday";
          }

          // ✨ Already completed birthday
          else if (birthDay < currentDay) {
            cardClass = "past-birthday";
          }

          return (
            <motion.div
              key={item.employee_code}
              className="col-md-6 col-lg-3 mb-lg-5 mb-3 "
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <div className={`birthday-card shadow ${cardClass}`}>

                {/* IMAGE */}
                <div className="birthday-img">
                  {/* <img src={imageUrl+item.employee_code.trim()+".jpg"} alt="birthday" /> */}

                <img
                  src={`${imageUrl}${parseInt(item.employee_code, 10)}.jpg`}
                  alt="birthday"
                  onError={(e) => {
                    if (!e.target.dataset.fallback) {
                      e.target.dataset.fallback = "true";
                      e.target.src = `${imageUrl}${parseInt(item.employee_code, 10)}.png`;
                    } else {
                      e.target.src = cake;
                    }
                  }}
                />

                </div>

                {/* FOOTER INFO */}
                <div className="birthday-info">

                  <h5 className="emp-name">{item.emp_name}</h5>

                  <p className="dept">{item.department}</p>

                  <p className="date">
                    {formatDate(item.date_of_birth)}
                  </p>

                </div>

              </div>
            </motion.div>
          );
        })}

        </div>
      )}

      </div>
  );
};

export default Birthday;